import React from "react";
import GapButton from "../gap-button/GapButton";
import Modal from "../modal/Modal";
import TextArea from "../text-area/TextArea";

const AddNotesModal = ({ setModalShow, submitNotes }) => {

    const [notes, setNotes] = React.useState("");
    const [notesError, setNotesError] = React.useState(false);
    const [notesLength, setNotesLength] = React.useState(0);

    const handleNotesData = () => {
        setModalShow(false);
        submitNotes(notes);
    }

    return (
        <React.Fragment>
            <Modal>
                <div className="add-modal-content">
                    <div className="close-icon-container">
                        <i
                            data-testid="closed-user-add-document-icon"
                            className="fa fa-times cursor-pointer"
                            onClick={() => {
                                setModalShow(false);
                            }}
                        />
                    </div>
                    <h6 className="add-modal-header">
                        Add Note
                    </h6>
                    <div className="mt-10">
                        <TextArea
                            label="Enter your note"
                            cols={44}
                            rows={10}
                            maxLength={500}
                            handleChange={(e) => {
                                setNotes(e.target.value);
                                setNotesLength(e.target.value?.length);
                                e.target.value ? setNotesError(false) : setNotesError(true);
                            }}
                            name="add_notes"
                            placeholder="in 500 characters or less, enter your note"
                        />
                        {notesError && (
                            <div className="error-container"><i className="fa fa-exclamation-circle error-icon"></i><div className="error-message">Note is required.</div></div>
                        )}
                        <span className="claim-description mt-5">{notesLength}/500</span>
                    </div>
                    <div className="add-notes-modal-footer-border" />
                    <div className="add-notes-modal-footer-container">
                        <GapButton
                            id="add-notes-modal-cancel"
                            buttonType="button"
                            buttonClass="cancle-button"
                            buttonLabel="Cancel"
                            onClick={() => {
                                setModalShow(false);
                            }}
                        />
                        <GapButton
                            id="add-notes-modal-submit"
                            buttonType="button"
                            onClick={() => { handleNotesData() }}
                            buttonLabel="Save"
                            disabled={notes?.length == 0}
                            buttonClass="save-btn"
                        />
                    </div>
                </div>
            </Modal>
        </React.Fragment>
    )
};

export default AddNotesModal;